import { Box, Drawer, Paper, Typography, useMediaQuery, useTheme } from '@mui/material'
import Header from 'components/Header'
import { useTranslation } from 'react-i18next'
import UserMenu from 'components/UserMenu'
import MenuIcon from '@mui/icons-material/Menu'
import HistoryIcon from '@mui/icons-material/HistoryOutlined'
import AppMenu from 'components/AppMenu'
import { useState } from 'react'
import { useSession } from '../Providers'

function PageHeader({ title, button }) {
  const { t } = useTranslation()
  const { academicYear } = useSession()
  const theme = useTheme()
  const isNonActiveYear = academicYear?.academicYearProviderId &&
    academicYear?.activeAcademicYearProviderId &&
    academicYear.academicYearProviderId !== academicYear.activeAcademicYearProviderId
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <>
      {isNonActiveYear && (
        <Box
          sx={{
            bgcolor: 'warning.main',
            px: 2,
            py: 0.75,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            borderRadius: '5px 5px 0 0',
          }}
        >
          <HistoryIcon sx={{ color: 'warning.contrastText', fontSize: 32 }} />
          <Typography variant="body2" sx={{ color: 'warning.contrastText', fontWeight: 600 }}>
            {t('You are viewing')} <strong>{academicYear?.name}</strong> — {t('this is not the current academic year')}
          </Typography>
        </Box>
      )}
      <Paper sx={{ borderRadius: isNonActiveYear ? '0 0 5px 5px' : '5px' }}>
        <Box display="flex" justifyContent="space-between" width="100%" maxHeight="82px" sx={{ p: '20px', borderRadius: '5px', alignItems: 'center'}}>
          <Box sx={{ml: -2, display: 'flex', alignItems: 'center'}} >
            {isSmallScreen && (
              <MenuIcon onClick={handleDrawerToggle} sx={{fontSize: '36px', color: 'primary.main' }} />
            )}  
            <Header title={t(`${title}`)}  />
          </Box>
          <Box display="flex">
            {button && (
              <Box display="flex" alignItems="center" flexGrow={{ sm: 1, md: 0, lg: 2 }}>
                {button}
              </Box>
            )}
          </Box>
          <Box display="flex" alignItems="center">
            <UserMenu />
          </Box>
          <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // For better performance on mobile
        }}
        sx={{          
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 240,
            boxSizing: 'border-box',
            backgroundColor: 'primary.main',
            borderRight: 'none',
            transition: 'width 0.3s'
          },
        }}
        PaperProps={{
          sx: {
            height: '100%',
            overflow: 'auto',
          },
        }}
      >
        <AppMenu />
      </Drawer>
        </Box>
      </Paper>
    </>
  )
}

export default PageHeader
